<template>
	<Teleport to="#js-program-page__info" :disabled="!isViewportSmall">
		<div class="programpage__info" ref="programPageInfoRef">
			<div v-if="model.Place" class="programpage__info-box">
				<h2 class="programpage__label">{{ translations.Place }}</h2>
				<span class="programpage__value">
					<p v-if="model.Place.Location">
						{{ model.Place.Location }}
					</p>
					<p v-else :aria-label="translations.EmptyField">-</p>
					<p>
						<span
							:aria-label="
								model.Place.StreetNameAndNumber
									? ''
									: translations.EmptyField
							"
							>{{
								model.Place.StreetNameAndNumber
									? model.Place.StreetNameAndNumber
									: "-"
							}}</span
						>
					</p>

					<p>
						<span
							:aria-label="
								model.Place.ZipCodeAndCity
									? ''
									: translations.ZipCodeAndCity
							"
						>
							{{
								model.Place.ZipCodeAndCity
									? model.Place.ZipCodeAndCity
									: "-"
							}}
						</span>
					</p>
				</span>
			</div>
			<div class="programpage__info-box">
				<h2 class="programpage__label">{{ translations.Date }}</h2>
				<span class="programpage__value">
					<p
						:aria-label="
							model.Date != '' ? '' : translations.EmptyField
						"
					>
						{{ model.Date ? model.Date : "-" }}
					</p>
				</span>
			</div>

			<div class="programpage__info-box">
				<h2 class="programpage__label">{{ translations.Time }}</h2>
				<span class="programpage__value">
					<p
						:aria-label="
							model.Time != '' ? '' : translations.EmptyField
						"
					>
						{{ model.Time ? model.Time : "-" }}
					</p>
				</span>
			</div>
			<div class="programpage__info-box">
				<h2 class="programpage__label">{{ translations.Price }}</h2>
				<span class="programpage__value">
					<p
						:aria-label="
							model.Price != '' ? '' : translations.EmptyField
						"
					>
						{{ model.Price ? model.Price : "-" }}
					</p>
				</span>
			</div>
			<div class="programpage__info-box">
				<h2 class="programpage__label">
					{{ translations.Categories }}
				</h2>
				<span class="programpage__value">
					<p
						:aria-label="
							model.Tags != '' ? '' : translations.EmptyField
						"
						v-html="model.Tags != '' ? model.Tags : '-'"
					></p>
				</span>
			</div>
		</div>
	</Teleport>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const screenSize = ref("");
const translations = ref({});
const model = ref({});

const programPageInfoRef = ref("programPageInfoRef");

const isViewportSmall = computed(() => {
	return (
		screenSize.value == "xsmall" ||
		screenSize.value == "small" ||
		screenSize.value == "smallx"
	);
});

onMounted(() => {
	const dataProps = programPageInfoRef.value?.parentElement?.dataset;
	if (dataProps) {
		translations.value = JSON.parse(dataProps.translations);
		model.value = JSON.parse(dataProps.model);
	}

	screenSize.value = utilities.getSize();
	utilities.emitter.on("responsive/sizechange", (size) => {
		screenSize.value = size;
	});
});
</script>
